import { useEffect, useState } from "react";
import { PaymentsRoutesResponse, v4Service, VerificationType } from "src/api";
import { useUrlParamsContext } from "src/contexts";

const defaultPaymentsRoutes: PaymentsRoutesResponse = {
  verification_type: VerificationType.None,
};

export const usePaymentsRoutes = () => {
  const [paymentsRoutes, setPaymentsRoutes] = useState<PaymentsRoutesResponse>(defaultPaymentsRoutes);
  const [paymentsRoutesLoading, setPaymentsRoutesLoading] = useState<boolean>(false);
  const [paymentsRoutesError, setPaymentsRoutesError] = useState<string | null>(null);
  const { paymentRouteId } = useUrlParamsContext();

  useEffect(() => {
    const fetchPaymentsRoutes = async () => {
      if (!paymentRouteId) return;

      setPaymentsRoutesLoading(true);
      try {
        const paymentsRoutesResponse = await v4Service.getPaymentsRoutes({
          payment_route_id: paymentRouteId,
        });
        setPaymentsRoutes(paymentsRoutesResponse.length > 0 ? paymentsRoutesResponse[0] : defaultPaymentsRoutes);
      } catch (error) {
        setPaymentsRoutesError(String(error));
      } finally {
        setPaymentsRoutesLoading(false);
      }
    };

    fetchPaymentsRoutes();
  }, [paymentRouteId]);

  return {
    paymentsRoutes,
    paymentsRoutesLoading,
    paymentsRoutesError,
  };
};
